/**
 * Delivery-address columns on quotes/sales orders (deladd*) map to branch shipping
 * form fields (braddress*) the same way as server/system/library/weberp/pos.php createQuote.
 */

export interface DeladdHeaderLike {
	deladd1?: string | null;
	deladd2?: string | null;
	deladd3?: string | null;
	deladd4?: string | null;
	deladd5?: string | null;
	deladd6?: string | null;
	deliverto?: string | null;
}

export function deladdHeaderToBranchShipping(h: DeladdHeaderLike): {
	braddress1: string;
	braddress2: string;
	braddress3: string;
	braddress4: string;
	braddress5: string;
	braddress6: string;
	brname: string;
} {
	const d = (v: string | null | undefined) => (v ?? '').toString();
	return {
		braddress1: d(h.deladd1),
		braddress2: d(h.deladd2),
		braddress3: d(h.deladd5),
		braddress4: d(h.deladd3),
		braddress5: d(h.deladd4),
		braddress6: d(h.deladd6),
		brname: d(h.deliverto),
	};
}

export function buildShiptoHtml(
	brname: string,
	a1: string,
	a2: string,
	a3: string,
	a4: string,
	a5: string,
	a6: string
): string {
	let shipto = brname + '</br>';
	shipto += a1 + '</br>';
	if (a2 !== '' && a2 != null) {
		shipto += a2 + '</br>';
	}
	shipto += a3 + ', ' + a4 + ' ' + a5 + ' ' + a6;
	return shipto;
}

/** Apply mapped branch shipping onto customer record (API expects these on customer). */
export function applyBranchShippingFieldsToCustomer(customer: any, shipping: ReturnType<typeof deladdHeaderToBranchShipping>): void {
	if (!customer || !shipping) {
		return;
	}
	customer.brname = shipping.brname;
	customer.deliverto = shipping.brname;
	customer.contactname = shipping.brname;
	customer.braddress1 = shipping.braddress1;
	customer.braddress2 = shipping.braddress2;
	customer.braddress3 = shipping.braddress3;
	customer.braddress4 = shipping.braddress4;
	customer.braddress5 = shipping.braddress5;
	customer.braddress6 = shipping.braddress6;
	customer.shipto = buildShiptoHtml(
		shipping.brname,
		shipping.braddress1,
		shipping.braddress2,
		shipping.braddress3,
		shipping.braddress4,
		shipping.braddress5,
		shipping.braddress6
	);
}

/** Merge shipping controls from order form into customer before saveQuote / wire payloads. */
export function applyOrderFormShippingToCustomer(customer: any, formRaw: Record<string, unknown>): void {
	if (!customer || !formRaw) {
		return;
	}
	const s = (k: string) => (formRaw[k] != null ? String(formRaw[k]) : '');
	const brname = s('brname');
	const a1 = s('braddress1');
	const a2 = s('braddress2');
	const a3 = s('braddress3');
	const a4 = s('braddress4');
	const a5 = s('braddress5');
	const a6 = s('braddress6');
	customer.brname = brname;
	customer.deliverto = brname;
	customer.contactname = brname;
	if (formRaw['branchcode'] !== undefined && formRaw['branchcode'] !== null) {
		customer.branchcode = formRaw['branchcode'];
	}
	customer.braddress1 = a1;
	customer.braddress2 = a2;
	customer.braddress3 = a3;
	customer.braddress4 = a4;
	customer.braddress5 = a5;
	customer.braddress6 = a6;
	customer.shipto = buildShiptoHtml(brname, a1, a2, a3, a4, a5, a6);
}
